var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDmg = function SvgDmg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#576D7E",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.282 18c-.198 0-.414-.109-.414-.372v-3.406c0-.216.216-.372.414-.372h1.373c2.741 0 2.68 4.15.054 4.15zm.378-3.418v2.686h.995c1.62 0 1.691-2.687 0-2.687zM9.32 15.368v2.218c0 .265-.216.414-.432.414-.192 0-.36-.15-.36-.414V14.21a.4.4 0 0 1 .36-.415c.174 0 .276.103.378.217l1.32 1.78 1.366-1.847c.199-.245.684-.15.684.265v3.376c0 .265-.169.414-.36.414-.215 0-.384-.15-.384-.414v-2.218l-.995 1.259c-.215.265-.485.265-.683 0zM17.149 17.539c-.426.353-.948.504-1.475.504-1.26 0-2.154-.72-2.154-2.147 0-1.212.942-2.153 2.207-2.153.474 0 .995.162 1.367.528.366.36-.162.893-.521.576-.222-.217-.534-.378-.846-.378-.725 0-1.427.581-1.427 1.427 0 .887.588 1.427 1.374 1.427.365 0 .677-.108.899-.27v-.737h-.9c-.533 0-.48-.732 0-.732h1.2c.222 0 .425.168.425.354v1.277c0 .108-.047.209-.15.324"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default SvgDmg;